import { types } from '../types/types';

const initialState = {
    logs: [],
    total: 0,
    stats: null
};

export const smsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.smsLogsLoad:
            return {
                ...state,
                logs: action.payload.logs,
                total: action.payload.total
            };
        case types.smsStatsLoad:
            return {
                ...state,
                stats: action.payload
            };
        case types.smsLogoutCleaning:
            return initialState;
        default:
            return state;
    }
};